import posthog from 'posthog-js';

// Project API key is a public, write-only token — safe to ship client-side
// (same model as a Google Analytics measurement ID). REACT_APP_POSTHOG_KEY
// can override it per-environment if ever needed, but works out of the box.
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || 'phc_kfzX2umgyVLWrtFPK8ypxvBthex7AKaBTHPjmf3KQBbg';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export function initPostHog() {
  if (process.env.NODE_ENV === 'test') return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    autocapture: true,
  });
}

export default posthog;
